// src/sim/turn.ts -- pure, no DOM
import type { GameState } from './state';
import { randRange } from './rng';

/** Check if all resolution is complete (safe to advance turn) */
export function isResolved(state: GameState): boolean {
  return state.projectiles.activeCount === 0 && !state.collapsing && state.turn.deathQueue.length === 0;
}

/** Check if round is over (0 or 1 tanks alive) */
export function checkRoundOver(state: GameState): boolean {
  const alive = state.tanks.filter(t => t.alive).length;
  return alive <= 1;
}

/** Advance to next living player. Mutates state.turn. */
export function advanceTurn(state: GameState): void {
  const { tanks, turn } = state;
  let next = (turn.currentPlayer + 1) % tanks.length;
  let checked = 0;
  while (!tanks[next].alive && checked < tanks.length) {
    next = (next + 1) % tanks.length;
    checked++;
  }
  turn.currentPlayer = next;
  turn.phase = 'aiming';

  if (turn.windPerTurn) {
    state.world.wind = randRange(state.rng, -20, 20);
  }
}
